export default function () {
	const id = 'js-error'
	const el = document.getElementById(id)
	if (!el) return
	var data = JSON.parse(el.textContent);

	const lines = data?.__all__?.map(i => `<div js-error-line ><svg js-error-icon width="20" height="20" viewBox="0 0 512 512" fill="none" stroke="currentColor" stroke-width="32" aria-hidden="true"><circle cx="256" cy="256" r="192"/><path stroke-linecap="round" d="M250.26 166.05 256 288l5.73-121.95a5.74 5.74 0 0 0-5.79-6h0a5.74 5.74 0 0 0-5.68 6z"/><circle cx="256" cy="348" r="16" fill="currentColor" stroke="none"/></svg><p>${i}</p></div>`)
	if (!lines?.length) return
	const wrapper = document.createElement('div')
	wrapper.setAttribute('js-error-wrapper', true)
	wrapper.innerHTML = lines.join()

	el.insertAdjacentElement('afterend', wrapper)

}